import { useContext } from 'react';
import ModalContext from 'src/contexts/ModalContext';

const useModal = () => {
  return useContext(ModalContext);
};

export default useModal;
